import React from 'react';

export type CategoryFilterOpenState = {
    isOpen: boolean;
    open: () => void;
    /** Wired to the Autocomplete's controlled `isOpen`/`onOpenChange` props. */
    onOpenChange: (open: boolean) => void;
};

/**
 * The category filter's own open/closed state, kept out of `CategoryFilter.tsx`
 * so it can be tested without rendering the real popover. `onOpenChange` runs
 * for every route the popover closes by (`Escape`, an outside click, a blur).
 * Focus goes home once the popover has actually unmounted, through
 * `CategoryFilterPopoverExit`, not from here: the popover still holds focus
 * while it closes.
 */
export const useCategoryFilterOpenState = (): CategoryFilterOpenState => {
    const [isOpen, setIsOpen] = React.useState(false);

    const open = React.useCallback(() => setIsOpen(true), []);

    const onOpenChange = React.useCallback(
        (nextOpen: boolean) => setIsOpen(nextOpen),
        [],
    );

    return { isOpen, open, onOpenChange };
};
